(() => {
  const modal = document.querySelector('[data-video-modal]');
  const media = modal?.querySelector('[data-video-modal-media]');
  const player = modal?.querySelector('[data-video-modal-player]');

  if (!modal || !media || !player || modal.dataset.initialized === 'true') {
    return;
  }

  modal.dataset.initialized = 'true';

  const resetPlayer = () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
  };

  const closeModal = () => {
    resetPlayer();

    if (modal.open) {
      modal.close();
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-video-popup-trigger]');

    if (trigger) {
      const videoUrlDesktop = trigger.dataset.videoUrlDesktop;
      const videoUrlMobile = trigger.dataset.videoUrlMobile;
      const videoUrl = trigger.dataset.videoUrl; // Fallback for single video

      // Choose video based on screen size. The aspect ratio travels with the
      // URL: the dialog sizes its box from it before the video has metadata,
      // otherwise the box opens at the 300x150 default and jumps once the
      // first bytes land (see snippets/video-modal.liquid).
      let selectedVideoUrl;
      let selectedAspect;
      if (videoUrl) {
        // Single video mode
        selectedVideoUrl = videoUrl;
        selectedAspect = trigger.dataset.videoAspect;
      } else {
        // Desktop/mobile mode (hero, gallery, testimonials)
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const useMobile = Boolean(isMobile && videoUrlMobile);
        selectedVideoUrl = useMobile ? videoUrlMobile : videoUrlDesktop;
        selectedAspect = useMobile
          ? trigger.dataset.videoAspectMobile || '0.5625'
          : trigger.dataset.videoAspectDesktop || '1.7778';
      }

      if (!selectedVideoUrl) return;

      resetPlayer();

      const aspect = Number.parseFloat(selectedAspect);
      if (aspect > 0) {
        player.style.setProperty('--video-modal-aspect', String(aspect));
      } else {
        player.style.removeProperty('--video-modal-aspect');
      }

      player.src = selectedVideoUrl;
      player.load();

      modal.showModal();
      // The dialog itself, not the close button showModal() would pick: a phone rings it even
      // on a tap. Tab still reaches the button; Escape still closes.
      modal.focus({ preventScroll: true });

      player.play().catch(() => {});

      return;
    }

    if (event.target.closest('[data-video-modal-close]')) {
      closeModal();
    }
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  modal.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });
})();
